import { Box, Spinner, StatusIndicator } from '@cloudscape-design/components';
import { LoadingMessage } from '../../common/types';

export type RenderedLoadingMessageProps = {
  message: LoadingMessage;
};

export default function RenderedLoadingMessage(props: RenderedLoadingMessageProps) {
  const loadingMessage = props.message;

  return (
    <Box variant="p">
      <Spinner size="normal" /> Loading...
    </Box>
  );
}
